export default __webpack_public_path__ + "static/media/rewards.c6051e11.png";